/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Exclusions_WordsInputs */

const en_us2_search_field_exclusions_words = /** @type {(inputs: Search_Field_Exclusions_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exclude block never suggest remove`)
};

const pt_br2_search_field_exclusions_words = /** @type {(inputs: Search_Field_Exclusions_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`excluir bloquear nao recomendar remover`)
};

const es_419_search_field_exclusions_words = /** @type {(inputs: Search_Field_Exclusions_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`excluir bloquear no recomendar quitar`)
};

const pt_pt2_search_field_exclusions_words = /** @type {(inputs: Search_Field_Exclusions_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`excluir bloquear nao recomendar remover`)
};

const fr_fr2_search_field_exclusions_words = /** @type {(inputs: Search_Field_Exclusions_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exclure bloquer jamais suggerer retirer`)
};

const de_de2_search_field_exclusions_words = /** @type {(inputs: Search_Field_Exclusions_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ausschließen sperren nie vorschlagen entfernen`)
};

const it_it2_search_field_exclusions_words = /** @type {(inputs: Search_Field_Exclusions_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`escludi blocca mai suggerire rimuovi`)
};

/**
* | output |
* | --- |
* | "exclude block never suggest remove" |
*
* @param {Search_Field_Exclusions_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_exclusions_words = /** @type {((inputs?: Search_Field_Exclusions_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Exclusions_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_exclusions_words(inputs)
	if (locale === "es-419") return es_419_search_field_exclusions_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_exclusions_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_exclusions_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_exclusions_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_exclusions_words(inputs)
	return en_us2_search_field_exclusions_words(inputs)
});
export { search_field_exclusions_words as "search.field_exclusions_words" }